import { FormProvider, useForm } from 'react-hook-form';
import {
    FormStep1,
    FormStep10,
    FormStep11,
    FormStep3,
    FormStep4,
    FormStep5,
    FormStep6,
    FormStep8,
    FormStep12
} from './steps';
import { getErrorMessage, submitForm } from '../../lib/utils';
import { useAppContext, useFormDataContext, usePrePopContext, useLendersContext } from '../../lib/contexts';
import { CustomLoader } from '../CustomComponents';
import isEmpty from 'lodash/isEmpty';
import { useNavigate } from 'react-router-dom';
import {useEffect, useState} from 'react';
import { normalizeForQueryParams } from '../../lib/utils/maoQueryMapper';
import FormStep13 from "./steps/FormStep13";

function FormEmbedded() {
    const { appContext } = useAppContext();
    const { formData, clearStorage, updateFormData } = useFormDataContext({});
    const methods = useForm({ defaultValues: formData, mode: 'onSubmit' });
    const { step } = formData;
    const [isLoading, setIsLoading] = useState(false);
    const { formState } = methods;
    const { errors } = formState;
    const className = `stepBar stepIframe${step}`;
    const navigate = useNavigate();
    const { setLendersContext } = useLendersContext();

    const handleGlobalSubmit = async (data) => {
        const combinedData = { ...data, ...formData, ...appContext };

        setIsLoading(true);

        await new Promise((resolve) => {
            setTimeout(resolve, 1000);
        });

        Object.keys(data).forEach((key) => {
            if (formData[key] === '' && data[key] !== '') {
                combinedData[key] = data[key];
            }
        });

        const submitResult = await submitForm(combinedData);

        let pixel = null;

        if (submitResult.pixel) {
            pixel = submitResult.pixel;
        }

        const lendersContextData = {
            name: `${formData.firstname} ${formData.lastname}`,
        };

        if (submitResult.lenders && submitResult.lenders.length) {
            lendersContextData.lenders = submitResult.lenders;
        }

        setLendersContext(lendersContextData);

        const queryParams = new URLSearchParams(normalizeForQueryParams(combinedData)).toString();
        const encodedParams = queryParams.replace(/\+/g, '%20').replace(/%40/g, '@');

        setIsLoading(false);

        if (submitResult.status == 'matched' && submitResult.lenders) {
            await navigate('/thank-you-lender-list',{ state: {pixel:pixel} });
        } else {
            await navigate(`/thank-you?${encodedParams}`, {
                state: { pixel: pixel, status: submitResult.status },
            });
        }

        clearStorage();
    };

    useEffect(() => {
        if (appContext.prepop) {
            updateFormData({
                firstname: appContext.prepop.firstname || formData.firstname,
                lastname: appContext.prepop.lastname || formData.lastname,
                email: appContext.prepop.email || formData.email,
                phone: appContext.prepop.phone || formData.phone,
                zip: formData.zip || appContext.prepop.zip,
                address: appContext.prepop.address || formData.address,
            });
        }
    }, [appContext]);

    return (
        <>
            <CustomLoader isLoading={isLoading} />
            <div className="step-form-wrap embedded">
                <div className={className}>
                    <div className="steps col-12">
                        <span>Step &nbsp;</span>
                        <span className="current">{step} </span> &nbsp;/ 11
                    </div>
                </div>
                <FormProvider {...methods}>
                    <form
                        id="leadform"
                        className="step-form"
                        name="leadform"
                        onSubmit={methods.handleSubmit(handleGlobalSubmit)}
                        data-tf-element-role="offer"
                    >
                        <div className="step active" data-step={step}></div>
                        <div className="inner">
                            {!isEmpty(errors) && (
                                <div className="errors">{getErrorMessage(errors)}</div>
                            )}
                            {step === 1 && <FormStep5 hideBackButton={true}/>}
                            {step === 2 && <FormStep1 />}
                            {step === 3 && <FormStep8 />}
                            {step === 4 && <FormStep3 />}
                            {step === 5 && <FormStep4 />}
                            {step === 6 && <FormStep12 />}
                            {step === 7 && <FormStep6 />}
                            {step === 8 && <FormStep13 />}
                            {step === 9 && <FormStep10 />}
                            {step === 10 && <FormStep11 />}
                        </div>
                    </form>
                </FormProvider>{' '}
            </div>
        </>
    );
}

export default FormEmbedded;
